import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
// import router from '../../src/router'

/* eslint-disable */
export default {
    state: {
        questions: [],
        points: [],
        markers: [],
        mapParameters: '',
        imageUrl: '',
        gameData: '',
        sentence: '',
        welcomePageData: "",
        loading: false,
        results: [],
        questionsList: '',
        lang: 'he'
    },
    mutations: {
        switchLang(state, payload) {
            state.lang = payload
        },
        setQuestionList(state, payload) {
            // console.log("[setQuestionList] payload", payload)
            state.questionsList = payload
        },
        addResult(state, payload) {
            state.results.push(payload)
        },
        setMapParameters(state, payload) {
            state.mapParameters = payload
        },
        setWelcomePage(state, payload) {
            // console.log('[mutations] setWelcomePage payload', payload)
            state.welcomePage = payload
        },
        setLettersArray(state, payload) {
            state.lettersArray = payload
        },
        setGameParameters(state, payload) {
            state.gameParameters = payload
        },
        setAllNavGameNames(state, payload) {
            state.allNavGameNames = payload
        },
        setUser(state, payload) {
            // console.log("[setUser] payload", payload)
            state.user = payload
        },
        setLoading(state, payload) {
            state.loading = payload
            // console.log("[mutations] setLoading => state.loading", state.loading)
        },
        setPointsArray(state, payload) {
            // console.log('[setPointsArray] payload', payload)
            state.pointsArrayOrder = payload
        },
        setPoints(state, payload) {
            state.points = payload
        },
        setMarkers(state, payload) {
            state.markers = payload
        },
        setQuestions(state, payload) {
            state.questions = payload
        },
        setQuestionsSuffled(state, payload) {
            state.questionsShuffled = payload
        },
        addPoint(state, payload) {
            state.points.push(payload)
        },
        addMarker(state, payload) {
            state.markers.push(payload)
        },
        // setResults(state, payload) {
        //     state.allResults = payload
        // }
    },
    actions: {
        sendEmail({

        }, payload) {
            const db = firebase.database()
            db.ref(payload.navigationName + '/emails/').push(payload.email)
        },
        addEvolutionToDB({ }, payload) {
            const db = firebase.database()
            db.ref(payload.navigationName + '/users/' + payload.userKey + "/evolution/").set({
                pointNumber: payload.pointNumber
            })
        },
        checkResults({
            getters,
            dispatch
        }, payload) {
            let userName = getters.user.userName
            let navigationName = getters.gameParameters.navigationName
            const db = firebase.database()
            var pad = function (num, size) {
                return ("000" + num).slice(size * -1);
            },
                time = parseFloat(payload.gameTimeInSecond + payload.errorNumber * 60).toFixed(3),
                hours = Math.floor(time / 60 / 60),
                minutes = Math.floor(time / 60) % 60,
                seconds = Math.floor(time - minutes * 60);

            var totalTime =
                pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
            // db.ref('groups/results/' + userName).set(errors)
            var totalSeconds = payload.gameTimeInSecond + payload.errorNumber * 60
            db.ref(navigationName + '/results/').push({
                errorNumber: payload.errorNumber,
                secondsToTime: payload.gameSecondToTime,
                totalSeconds: totalSeconds,
                totalTime: totalTime,
                userName: userName
            })
        },
        getResults({
            dispatch,
            commit
        }, payload) {
            // console.log("getResuts")
            // console.log("document.getElementById(results)", document.getElementById("results"))
            const db = firebase.database()

            db.ref(payload + '/results').orderByChild('totalSeconds').on('value', resultsInfoOrderByChild => {
                let index = 0;
                resultsInfoOrderByChild.forEach(function (results) {
                    index++
                    var resultsOfTheGame = results.val();
                    // console.log("resultsOfTheGame ", resultsOfTheGame)
                    commit('addResult', {
                        resultsOfTheGame: resultsOfTheGame,
                        place: index
                    })
                })
            })
        },
        storePointsOrder({ }, payload) {
            const db = firebase.database()
            db.ref(payload.navigationName + '/pointsOrder/').push(payload.pointsOrder)
            // console.log("[storePointsOrder] payload", payload)
        },
        storeMapParameters({ }, payload) {
            const db = firebase.database()
            // console.log("storeMapParameters => payload", payload)
            // if (payload.lat != '') {
            db.ref(payload.navigationName + '/mapParameters/lat').set(payload.lat)
            // }
            // if (payload.lng != '') {
            db.ref(payload.navigationName + '/mapParameters//lng').set(payload.lng)
            // }
            // if (payload.zoom != '') {
            db.ref(payload.navigationName + '/mapParameters//zoom').set(payload.zoom)
            // }
        },
        storeEndPoint({ }, payload) {
            const db = firebase.database()
            // console.log("storeEndPoint => payload", payload)
            db.ref(payload.navigationName + '/lastPoint').set(payload.endPoint)
        },
        createNewGame({
            commit,
            getters
        }, payload) {
            // console.log("[createNewGame] payload", payload)
            const db = firebase.database()
            db.ref(payload.navigationName).set(payload)
        },
        createNewPoint({
            commit,
            getters
        }, payload) {
            commit('setLoading', true)
            const db = firebase.database()
            db.ref(payload.navigationName + '/points/' + payload.pointNumber).set(payload)
                .then(_ => {
                    // I stock the event's image in FB storage
                    const filename = payload.image.name
                    // const ext = filename.slice(filename.lastIndexOf('.'))
                    const ext = 'png'
                    return firebase.storage().ref(payload.navigationName + '/points/' + payload.pointNumber + '.' + ext).put(payload.image)
                })
                .then(fileData => {
                    // imageUrl = fileData.metadata.downloadURLs[0]
                    firebase.storage().ref(payload.navigationName + '/points/' + payload.pointNumber + '.png').getDownloadURL()
                        .then(imageUrl => {
                            this.imageUrl = imageUrl
                            return firebase.database().ref(payload.navigationName + '/points').child(payload.pointNumber).update({
                                imageUrl: this.imageUrl
                            })
                        })
                        .then(_ => {
                            return firebase.database().ref(payload.navigationName + '/points/' + payload.pointNumber + '/pictures/' + payload.pointNumber).update({
                                imageUrl: this.imageUrl
                            })
                        })
                        .then(_ => {
                            return firebase.database().ref(payload.navigationName + '/points/' + payload.pointNumber + '/pictures/').once('value')
                        })
                        .then(data => {
                            this.pictures = data.val()
                        })
                    commit('addPoint', payload)
                    commit('setLoading', false)
                    // console.log('createNewPoint - payload', payload)
                })
        },
        createNewQuestion({
            commit,
            getters
        }, payload) {
            commit('setLoading', true)
            console.log("[createNewQuestion] payload", payload)
            const db = firebase.database()
            db.ref(payload.navigationName + '/questions').push(payload.question)
            commit('setLoading', false)
        },
        updatQuestion({
            commit,
            getters
        }, payload) {
            commit('setLoading', true)
            const db = firebase.database()
            db.ref(payload.navigationName + '/' + getters.lang + '/questions/' + payload.key).set(payload.question)
            commit('setLoading', false)

        },
        updatePoint({
            commit,
            getters
        }, payload) {
            console.log("updatePoint - payload", payload)
            commit('setLoading', true)
            const db = firebase.database()
            db.ref(payload.navigationName + '/' + getters.lang + '/points/' + payload.pointNumber).set(payload)
            commit('setLoading', false)

        },
        createNewMarker({
            commit
        }, payload) {
            const db = firebase.database()
            // console.log("[createNewMarker] payload", payload)
            commit('addMarker', payload.position)
            db.ref(payload.navigationName + '/markers/' + payload.pointNumber).set(payload.position)
        },
        createNewUser({
            commit
        }, payload) {
            const db = firebase.database()
            var navigationHour = new Date().toString()
            if (localStorage.getItem("userKey")) {
                db.ref(payload.navigationName + '/users/' + localStorage.getItem("userKey")).set({
                    userName: payload.userName,
                    NavigationTime: navigationHour,
                    groupColorEnglish: payload.groupColorEnglish,
                    evolution: {
                        pointNumber: payload.pointNumber
                    }
                })
                commit('setUser',
                    payload
                )
            } else {
                db.ref(payload.navigationName + '/users').push({
                    userName: payload.userName,
                    NavigationTime: navigationHour,
                    groupColorEnglish: payload.groupColorEnglish
                })
                    .then(user => {
                        localStorage.setItem("userKey", user.key);
                    })
                commit('setUser',
                    payload
                )
            }
            // db.ref(payload.navigationName + '/users').push({
            //         userName: payload.userName,
            //         NavigationTime: navigationHour,
            //         groupColorEnglish: payload.groupColorEnglish
            //     })
            //     .then(user => {
            //         localStorage.setItem("userKey", user.key);
            //     })
            // commit('setUser',
            //     payload
            // )
        },

        //   ******************************* FETCH PART ******************************************
        fetchAllNavGames({
            commit,
            dispatch,
            getters
        }) {
            commit('setLoading', true)
            firebase.database().ref().once('value')
                .then(data => {
                    // console.log("[fetchAllNavGames] data", data.val())
                    var namesOfNavGames = []
                    data.forEach(eachNavGame => {
                        namesOfNavGames.push(eachNavGame.key)
                    })
                    commit('setAllNavGameNames', namesOfNavGames)
                    commit('setLoading', false)
                })
        },
        fetchNavtigationData({
            commit,
            dispatch,
            getters
        }, payload) {
            commit('setLoading', true)
            // firebase.database().ref(payload).once('value')
            //     .then(data => {
            //         let navigationData = data.val()
            //         data.questions.forEach(question => {
            //             console.log("question.key", question.key)
            //         })
            //         console.log("[fetchNavtigationData] navigationData", navigationData)
            //         commit('setQuestionList', navigationData.questions)
            //     })
            firebase.database().ref(payload + '/' + getters.lang + '/questions').once('value')
                .then(data => {
                    let questions = []
                    data.forEach(question => {
                        // console.log("getters.lang", getters.lang)
                        // console.log("question.val()", question.val())
                        questions.push({
                            key: question.key,
                            data: question.val()
                        })
                        // questions.push()
                    })
                    console.log("[fetchNavtigationData] getters.lang", getters.lang)

                    console.log("[fetchNavtigationData] questions", questions)
                    // commit('setQuestionList', navigationData.questions)
                    commit('setQuestionList', questions)
                })
        },
        fetchConfirmationPhrase({
            commit
        }, payload) {
            commit('setLoading', true)
            firebase.database().ref(payload.navigationName).once('value')
                .then(data => {
                    this.welcomePageData = data.val()
                    // **************************FETCH GAME PARAMETERS
                    var gameParameters = {
                        welcomePhrase: this.welcomePageData.welcomePhrase,
                        buttonStartGame: this.welcomePageData.buttonStartGame,
                        welcomePhraseOne: this.welcomePageData.welcomePhraseOne,
                        welcomePhraseTwo: this.welcomePageData.welcomePhraseTwo,
                        welcomePhraseThree: this.welcomePageData.welcomePhraseThree,
                        welcomePhraseFour: this.welcomePageData.welcomePhraseFour,
                        welcomePhraseFive: this.welcomePageData.welcomePhraseFive,
                    }
                    commit('setWelcomePage', gameParameters)
                })
            commit('setLoading', false)
        },
        fetchPoints({
            commit,
            getters
        }, payload) {
            commit('setLoading', true)
            firebase.database().ref(payload).once('value')
                .then(data => {
                    // if (getters.lang == "fr") {
                    this.points = data.val().fr.points
                    // } else {
                    //     this.points = data.val().en.points
                    // }
                    console.log("[fetchPoints] this.points", this.points)
                    commit('setPoints', this.points)
                })
            commit('setLoading', false)

        },
        fetchGameData({
            commit,
            dispatch,
            getters
        }, payload) {
            commit('setLoading', true)

            firebase.database().ref(payload.navigationName).once('value')
                .then(data => {
                    this.gameData = data.val()
                    console.log("this.gameData = data.val()", this.gameData)
                    // **************************FETCH GAME PARAMETERS
                    var gameParameters = {
                        anniversary: this.gameData.anniversary,
                        infoPage: this.gameData.infoPage,
                        navigationName: this.gameData.navigationName,
                        randomQuestions: this.gameData.randomQuestions,
                        lastPoint: this.gameData.lastPoint
                    }
                    commit('setGameParameters', gameParameters)
                    // console.log("gameParameters", gameParameters)

                    // **************************FETCH POINTS
                    // if (getters.lang == "fr") {

                    this.points = data.val().fr.points
                    // } else {
                    //     this.points = data.val().en.points
                    // }
                    console.log("[fetchPoints] this.points", this.points)
                    commit('setPoints', this.points)
                    // **************************FETCH MAP PARAMERTERS
                    this.mapParameters = data.val().mapParameters
                    // console.log("[fetchPoints] this.mapParameters", this.mapParameters)
                    commit('setMapParameters', this.mapParameters)

                    // **************************FETCH MARKERS

                    this.markers = data.val().markers
                    // console.log("[fetchPoints] this.markers", this.markers)
                    commit('setMarkers', this.markers)

                    // **************************FETCH POINTS ORDER && QUESTIONS
                    var arraysOfPointsOrder = Object.values(data.val().pointsOrder)
                    var randomPointsOrder = arraysOfPointsOrder[Math.floor(Math.random() * arraysOfPointsOrder.length)];
                    commit('setPointsArray', randomPointsOrder)
                    // if (getters.lang == "fr") {
                    dispatch('checkQuestionListToBeSent', {
                        questions: data.val().fr.questions,
                        randomPointsOrder: randomPointsOrder
                    })
                    // } else {
                    //     dispatch('checkQuestionListToBeSent', {
                    //         questions: data.val().en.questions,
                    //         randomPointsOrder: randomPointsOrder
                    //     })
                    // }
                })
        },

        // fetchSentence({
        //     commit,
        //     getters
        // }, payload) {
        //     setTimeout(_ => {
        //         let userColor = getters.user.groupColorEnglish
        //         if (userColor) {
        //             firebase.database().ref(payload.navigationName + '/sentence/' + userColor + 'Sentence').once('value')
        //                 .then(sentence => {
        //                     this.sentence = sentence.val()
        //                     let arrayOfLetters = Array.from(this.sentence)
        //                     // console.log("[fetchSentence] arrayOfLetters", arrayOfLetters)
        //                     commit('setLettersArray', arrayOfLetters)
        //                 })
        //         } else {
        //             this.fetchSentence
        //         }
        //     }, 1000)
        // },

        storeSentence({
            commit,
            getters
        }, payload) {
            let numberOfLetter = payload.sentence.length
            let sentenceByFour = Math.round(numberOfLetter / 4)
            let redSentence = payload.sentence.slice(0, sentenceByFour)
            let royalblueSentence = payload.sentence.slice(sentenceByFour, sentenceByFour * 2)
            let darkgreenSentence = payload.sentence.slice(sentenceByFour * 2, sentenceByFour * 3)
            let purpleSentence = payload.sentence.slice(sentenceByFour * 3, numberOfLetter)
            firebase.database().ref(payload.navigationName + '/sentence/redSentence').set(redSentence)
            firebase.database().ref(payload.navigationName + '/sentence/royalblueSentence').set(royalblueSentence)
            firebase.database().ref(payload.navigationName + '/sentence/darkgreenSentence').set(darkgreenSentence)
            firebase.database().ref(payload.navigationName + '/sentence/purpleSentence').set(purpleSentence)
        },

        checkQuestionListToBeSent({
            commit,
            dispatch,
            getters
        }, payload) {
            var questionArrayWihoutEmptyQuestion = []
            // var arrayQuestion = payload.questions
            // console.log("Object.values(payload.questions)", Object.values(payload.questions))
            var arrayQuestion = Object.values(payload.questions)
            arrayQuestion.forEach(question => {
                if (question != null) {
                    questionArrayWihoutEmptyQuestion.push(question)
                } else {
                    console.log("this question is empty", question)
                }
            })
            if (getters.user) {
                if (getters.gameParameters.randomQuestions === false) {
                    var questionArray = []
                    payload.randomPointsOrder.forEach(point => {
                        questionArrayWihoutEmptyQuestion.map(x => {
                            // if (x.questionNumber == point * 2 || x.questionNumber == point * 2 - 1) {
                            //     questionArray.push(x)
                            // } else {}
                            if (x.pointLinked == point) {
                                questionArray.push(x)
                            } else { }
                        })
                    })
                    commit('setQuestionsSuffled', questionArray)
                } else {
                    dispatch('suffleQuestions', questionArrayWihoutEmptyQuestion)
                }
            } else {
                dispatch('checkQuestionListToBeSent', questionArrayWihoutEmptyQuestion)
            }
            commit('setLoading', false)
        },

        suffleQuestions({
            commit,
            dispatch
        }, payload) {
            this.questions = payload
            let questionSuffled = this.questions;
            let currentIndex = questionSuffled.length,
                temporaryValue,
                randomIndex;
            // While there remain elements to shuffle...
            while (0 !== currentIndex) {
                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;
                // And swap it with the current element.
                temporaryValue = questionSuffled[currentIndex];
                questionSuffled[currentIndex] = questionSuffled[randomIndex];
                questionSuffled[randomIndex] = temporaryValue;
            }
            if (questionSuffled[0]) {
                commit('setQuestionsSuffled', questionSuffled)
                // commit('setLoading', false)
            } else {
                dispatch('suffleQuestions', payload)
            }
        },

        /////////////////////////////////////LANGUAGES////////////////////////////////
        switchLangToFrench({
            commit
        }) {
            commit('switchLang', "fr")
        },
        switchLangToEnglish({
            commit
        }) {
            commit('switchLang', "en")
        }
    },
    getters: {
        lang(state) {
            return state.lang
        },
        mapParameters(state) {
            return state.mapParameters
        },
        welcomePage(state) {
            return state.welcomePage
        },
        lettersArray(state) {
            return state.lettersArray
        },
        gameParameters(state) {
            return state.gameParameters
        },
        allNavGameNames(state) {
            return state.allNavGameNames
        },
        loading(state) {
            console.log("[getters] loading => state.loading", state.loading)
            return state.loading
        },
        results(state) {
            return state.results
        },
        user(state) {
            return state.user
        },
        points(state) {
            return state.points
        },
        markers(state) {
            return state.markers
        },
        questions(state) {
            return state.questions
        },
        questionsShuffled(state) {
            return state.questionsShuffled
        },
        group(state) {
            return state.group
        },
        pointsArrayOrder(state) {
            return state.pointsArrayOrder
        },
        questionsList(state) {
            return state.questionsList
        },
        getUser(state) {
            return (userId) => {
                return state.users.find((user) => {
                    return user.id === userId
                })
            }
        }
    }
}